import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { can, homePathFor, isWithoutOrganisation, NO_ORGANISATION_PATH, readSession } from "../../utils/organisationApi";

// Accounts with no active organisation stay on that screen, including after a refresh.
export const RequireOrganisation = () => {
  if (isWithoutOrganisation()) return <Navigate to={NO_ORGANISATION_PATH} replace />;
  return <Outlet />;
};

// Hides screens a role can't use. The backend still enforces every permission.
const RoleRoute = ({ permission, superAdmin = false }) => {
  const session = readSession();
  const allowed = superAdmin ? session.isSuperAdmin : can(session, permission);
  if (!allowed) {
    return <Navigate to={homePathFor(session)} replace />;
  }
  return <Outlet />;
};

export default RoleRoute;
